/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import type { RootState } from 'common/stores/redux/store';
import { TourData } from './slice';

export const selectVersions = (state: RootState): TourData[] =>
    state.tour.versions ?? [];

export const selectError = (state: RootState) => state.tour.error;
